import React from "react";
import TextField from "@material-ui/core/TextField";

type Props = {
  value: Record<string, unknown>;
  onChange: (newValue: Record<string, unknown>) => void;
};

export default function TestValue({value, onChange}: Props) {
  const {required = "", optional = "", max_fps: maxFPs = 0} = value;

  const handleChange = (field: "required" | "optional" | "max_fps") => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onChange({
      required: field === "required" ? event.target.value : value.required,
      optional: field === "optional" ? event.target.value : value.optional,
      max_fps: field === "max_fps" ? Number(event.target.value) : value.max_fps,
    });
  };

  return (
    <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
      <TextField
        value={required}
        onChange={handleChange("required")}
        label="Required"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
      <TextField
        value={optional}
        onChange={handleChange("optional")}
        label="Optional"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
      <TextField
        value={maxFPs}
        type="number"
        onChange={handleChange("max_fps")}
        label="Max FPs allowed (default = 0)"
        variant="outlined"
        multiline={false}
        style={{width: "30em"}}
      />
    </div>
  );
}
